import React, {ReactNode} from "react";
import {Dialog, DialogContent} from "@mui/material";

export function FormDialog(props: {
  open: boolean,
  handleClose: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void,
  children?: ReactNode;
}) {

  return (
    <Dialog fullWidth={true} maxWidth={"md"} open={props.open} onClose={props.handleClose} aria-labelledby="form dialog"
            PaperProps={{sx: {maxHeight: '80%'}}}>
      <DialogContent sx={{backgroundColor: 'background.paper',}}>
        {props.children}
      </DialogContent>
    </Dialog>
  );
}

